<!-- <div>
  <button style="float:right;" type="button" class="btn btn-primary text-center"  (click) ="signin()">Login</button>
  <button style="float:right;" type="button" class="btn btn-primary text-center" (click) ="signup()">Sign Up</button>
</div> -->

<div class="container">
  <div class="row top-menu-wr">
    <div class="col-md-8">
      <ul class="double-menu">
         <li>
            <a class="pointer" routerLink="/cashback-request" title="Cashback">
              <img src="/assets/images/cashback.png" alt="Cashback" 
                   onerror="this.innerHTML='<i class=&quot;fas fa-wallet&quot; style=&quot;font-size:24px;&quot;></i>'" 
                   title="Cashback" />
            </a>
          </li>
         <li>
            <a class="pointer" (click)="navigateToSection('Feedback')"><img src="/assets/images/feedback.png"
                title="Feedback" /></a>
          </li>
          <li>
            <a class="pointer" (click)="navigateToSection('Contact-us')"><img src="/assets/images/contact.png"
                title="Contact" /></a>
          </li>
           

          <div class="col-md-4">
            <div class="top-btn">
              <!-- <button type="button" class="btn btn-primary text-center" *ngIf="this.accessToken" (click) ="signInNew2()">Signout</button> -->
              <!-- <button *ngIf="isUserLoggedIn()" class="top-log-btn" style="color: red;float: right;font-weight: bold;font-family: Verdana, Geneva, Tahoma, sans-serif;font-size: x-large;" (click)="signOut()">logout</button> -->
            </div>
            <div>
              <!-- <button *ngIf="!isUserLoggedIn()" class="top-log-btn" routerLink="/login">Login</button> -->
            </div>
          </div>
          <!-- <button type="button" class="btn btn-primary text-center" *ngIf="!this.accessToken" (click) ="signIn()">Login1</button>
          <button type="button" class="btn btn-primary text-center" *ngIf="this.accessToken" (click) ="signOut()">Signout1</button> -->

          <!-- <li *ngIf="isUserLoggedIn()">
            <select 
            name="state">
              <option disabled value="" selected>
                Select
              </option>
              <option *ngFor="let url of slides_url" [value]="url.url">
                {{url.name}}
              </option>
            </select>
          </li> -->
      </ul>

    </div>

    <div class="col-md-4">
      <div class="top-btn">
        <a *ngIf="isUserLoggedIn()" class="top-log-btn" style="color: white;" (click)="signOut()">Signout</a>
        <!-- <button *ngIf="isUserLoggedIn()" class="top-log-btn" style="color: red;float: right;font-weight: bold;font-family: Verdana, Geneva, Tahoma, sans-serif;font-size: x-large;" (click)="signOut()">logout</button> -->

        <a *ngIf="!isUserLoggedIn()" class="top-log-btn" style="color: white;" routerLink="/login">Sign in or up</a>

      </div>

    </div>
  </div>
</div>
